import styled from 'styled-components'
import { fontType, toRem } from '../../shared/styles/functions'

export const Container = styled.div`
	& * {
		${fontType(0)};
	}
	.remove-user-content-modal {
		text-align: center;
		.button-container {
			display: flex;
			margin-top: 25px;
			justify-content: space-between;
			align-items: center;
		}
	}
`
export const PageHeader = styled.div`
	display: flex;
	justify-content: space-between;
`

export const TextForm = styled.div`
	margin: 10px 0;
	color: ${({ theme }) => theme.colors.darkGrey};
	font-size: 16px;
`
export const TableContent = styled.div`
	margin-top: ${toRem(40)};
	justify-content: center;
	display: flex;

	.table-container {
		width: 100%;
	}
	.table-role-content-operator {
		background-color: ${({ theme }) => theme.colors.lightBlue};
		border-radius: ${toRem(13)};
		opacity: 1;
		color: ${({ theme }) => theme.colors.blue};
		max-width: ${toRem(130)};
		padding: ${toRem(7)};
		font-size: ${toRem(10)};
		margin: ${toRem(2)};
	}

	.trash-icon,
	.settings-icon {
		img {
			cursor: pointer;
		}
	}
`
export const TableRetailContent = styled.span`
	background-color: ${({ theme }) => theme.colors.grey};
	border-radius: ${toRem(13)};
	opacity: 1;
	color: ${({ theme }) => theme.colors.lightWhite};
	max-width: ${toRem(130)};
	padding: ${toRem(7)};
	font-size: ${toRem(10)};
	margin: ${toRem(2)};
`

export const Line = styled.div`
	width: 100%;
	height: 1px;
	margin: 16px 0;
	background: ${({ theme }) => theme.colors.lightGrey2};
`

export const OfferContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	margin-bottom: 40px;

	.offers-texts {
		display: flex;
		flex-direction: column;
	}
	.offer-title {
		margin: 0 0 8px 0;
		color: ${({ theme }) => theme.colors.darkGrey};
		font-size: 16px;
	}
	.offer-subTitle {
		color: ${({ theme }) => theme.colors.darkGrey};
		font-size: 12px;
	}
`

export const ModalContent = styled.div`
	position: relative;
	${fontType(0)};

	.button-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: ${toRem(15)};
	}

	.input-container-wrapper {
		flex-direction: column;
		margin-top: ${toRem(30)};
		display: flex;
	}
	.select-container,
	.input-container,
	.select-retail {
		margin-top: ${toRem(10)};
		width: 100%;
		input[type='number']::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}
		input[type='number'] {
			-moz-appearance: textfield;
			appearance: textfield;
		}
	}

	.input-container-number {
		width: 30%;
	}

	.double-input-container {
		display: flex;
		flex-direction: row;
		gap: 10px;
	}

	.external-api-reference-load {
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 2;
	}
`

export const OfferModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;

	p {
		font-size: 16px;
	}

	.buttons {
		display: flex;
		align-items: center;
		margin-left: auto;
	}
`
